import { useTranslation, Trans } from 'react-i18next'

import { Link } from 'src/components/Link/Link'
import { Text } from 'src/components/Text/Text'

export const CoffeeFoundationElement = () => {
  const { t } = useTranslation()

  return (
    <Text variant="p">
      <Trans
        i18nKey="pdp.accordion.coffee.coffeeFoundation.text"
        components={[
          <Link
            key="contact-form-link"
            href={t('pdp.accordion.coffee.coffeeFoundation.link')}
            target="_blank"
            aria-label={`${t('pdp.accordion.coffee.coffeeFoundation.title')} - ${t('common.newTab')}`}
          />,
        ]}
      />
    </Text>
  )
}
